import { defineTapPropertyExtension } from '@iotize/tap';

import { TapAuth } from './tap-auth';
import { TapEncryption } from './tap-encryption';

// Create tap extension to provide datalogger class

declare module '@iotize/tap/lib/tap' {
  interface Tap {
    auth: TapAuth;
  }
}

export const _TAP_EXTENSION_AUTH_ = defineTapPropertyExtension(
  'auth',
  (context) => new TapAuth(context.tap),
);
